import { render, staticRenderFns } from "./DataPiutang.vue?vue&type=template&id=9b74af8c&"
import script from "./DataPiutang.vue?vue&type=script&lang=js&"
export * from "./DataPiutang.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports